var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsSolid = function SvgTagsSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m9.121 2.928-.195.176L2.05 9.979l-.43.449.43.449 5.625 5.625.449.43.45-.43 6.874-6.875.176-.195V2.928zm.527 1.25h4.727v4.726l-6.25 6.25-4.727-4.726zm6.602.625v1.25h.625v5.097l-5.937 5.899-.782-.781-.879.878 1.211 1.231.45.43.43-.43 6.581-6.504.176-.195V4.803zm-3.75.625a.626.626 0 0 0 0 1.25.626.626 0 0 0 0-1.25"
  })));
};
export default SvgTagsSolid;